var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path0, _g5, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoPlanGold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 113,
    viewBox: "0 0 402 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11003 56.44C6.11003 28.64 28.64 6.11002 56.44 6.11002C84.24 6.11002 106.77 28.65 106.77 56.44C106.77 84.23 84.23 106.77 56.44 106.77C28.65 106.77 6.11003 84.23 6.11003 56.44ZM0.0300293 56.44C0.0300293 87.59 25.29 112.85 56.44 112.85C87.59 112.85 112.85 87.59 112.85 56.44C112.85 25.29 87.59 0.0200195 56.44 0.0200195C25.29 0.0200195 0.0300293 25.28 0.0300293 56.44Z",
    fill: "url(#paint0_linear_4_398)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 113
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11003 56.44C6.11003 28.64 28.64 6.11002 56.44 6.11002C84.24 6.11002 106.77 28.65 106.77 56.44C106.77 84.23 84.23 106.77 56.44 106.77C28.65 106.77 6.11003 84.23 6.11003 56.44ZM0.0300293 56.44C0.0300293 87.59 25.29 112.85 56.44 112.85C87.59 112.85 112.85 87.59 112.85 56.44C112.85 25.29 87.59 0.0200195 56.44 0.0200195C25.29 0.0200195 0.0300293 25.28 0.0300293 56.44Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.86 0.0300293H0.0300293V112.86H112.86V0.0300293Z",
    fill: "url(#paint1_linear_4_398)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.58 33.17C52.98 33.77 52.98 34.74 53.58 35.34C54.18 35.94 55.15 35.94 55.75 35.34C57.39 33.7 60.06 33.7 61.7 35.34C62.3 35.94 63.27 35.94 63.87 35.34C64.47 34.74 64.47 33.77 63.87 33.17C62.45 31.75 60.59 31.04 58.73 31.04C56.87 31.04 55 31.75 53.59 33.17",
    fill: "url(#paint2_linear_4_398)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4_398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 31,
    width: 12,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.58 33.17C52.98 33.77 52.98 34.74 53.58 35.34C54.18 35.94 55.15 35.94 55.75 35.34C57.39 33.7 60.06 33.7 61.7 35.34C62.3 35.94 63.27 35.94 63.87 35.34C64.47 34.74 64.47 33.77 63.87 33.17C62.45 31.75 60.59 31.04 58.73 31.04C56.87 31.04 55 31.75 53.59 33.17",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.47 31.05H52.98V35.94H64.47V31.05Z",
    fill: "url(#paint3_linear_4_398)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1701 29.03C49.5701 29.63 49.5701 30.6 50.1701 31.2C50.7701 31.8 51.7401 31.8 52.3401 31.2C55.8601 27.68 61.5901 27.68 65.1101 31.2C65.7101 31.8 66.6801 31.8 67.2801 31.2C67.8801 30.6 67.8801 29.63 67.2801 29.03C64.9201 26.67 61.8201 25.49 58.7201 25.49C55.6201 25.49 52.5201 26.67 50.1701 29.03Z",
    fill: "url(#paint4_linear_4_398)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4_398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 25,
    width: 19,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1701 29.03C49.5701 29.63 49.5701 30.6 50.1701 31.2C50.7701 31.8 51.7401 31.8 52.3401 31.2C55.8601 27.68 61.5901 27.68 65.1101 31.2C65.7101 31.8 66.6801 31.8 67.2801 31.2C67.8801 30.6 67.8801 29.63 67.2801 29.03C64.9201 26.67 61.8201 25.49 58.7201 25.49C55.6201 25.49 52.5201 26.67 50.1701 29.03Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8801 25.49H49.5701V31.8H67.8801V25.49Z",
    fill: "url(#paint5_linear_4_398)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.22 25.1999C45.62 25.7999 45.62 26.7699 46.22 27.3699C46.82 27.9699 47.79 27.9699 48.39 27.3699C54.21 21.5499 63.67 21.5499 69.49 27.3699C70.09 27.9699 71.06 27.9699 71.66 27.3699C72.26 26.7699 72.26 25.7999 71.66 25.1999C68.15 21.6899 63.55 19.9399 58.94 19.9399C54.33 19.9399 49.73 21.6899 46.23 25.1999",
    fill: "url(#paint6_linear_4_398)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4_398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 19,
    width: 28,
    height: 9
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.22 25.1999C45.62 25.7999 45.62 26.7699 46.22 27.3699C46.82 27.9699 47.79 27.9699 48.39 27.3699C54.21 21.5499 63.67 21.5499 69.49 27.3699C70.09 27.9699 71.06 27.9699 71.66 27.3699C72.26 26.7699 72.26 25.7999 71.66 25.1999C68.15 21.6899 63.55 19.9399 58.94 19.9399C54.33 19.9399 49.73 21.6899 46.23 25.1999",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.25 19.95H45.62V27.9799H72.25V19.95Z",
    fill: "url(#paint7_linear_4_398)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4001 83.0001C70.4001 80.8901 72.1101 79.1701 74.2301 79.1701C76.3501 79.1701 78.0601 80.8801 78.0601 83.0001C78.0601 85.1201 76.3501 86.8301 74.2301 86.8301C72.1101 86.8301 70.4001 85.1201 70.4001 83.0001ZM34.83 82.9201C34.83 80.8101 36.5401 79.0901 38.66 79.0901C40.78 79.0901 42.4901 80.8001 42.4901 82.9201C42.4901 85.0401 40.78 86.7501 38.66 86.7501C36.5401 86.7501 34.83 85.0401 34.83 82.9201ZM58.94 49.6001H65.1801C66.0501 49.6001 66.8801 49.9701 67.4501 50.6301L80.5701 65.5701H58.94V49.6001ZM54.9001 40.3601H51.0301C49.3601 40.3601 48 41.7201 48 43.3901V53.8401L44.0701 49.5001C39.7101 44.6801 33.8101 41.5901 27.4501 40.7001C27.4501 40.6101 27.4601 40.5201 27.4601 40.4301C27.4601 38.3201 25.7501 36.6001 23.6301 36.6001C21.5101 36.6001 19.8 38.3101 19.8 40.4301C19.8 42.5501 21.5101 44.2601 23.6301 44.2601H23.6501C22.4001 44.5701 21.4701 45.6901 21.4701 47.0301V56.5801H24.47C25.52 56.5801 26.3601 57.5301 26.1701 58.6201C26.0501 59.3101 25.4801 59.8801 24.7901 60.0001C23.7001 60.1901 22.7501 59.3601 22.7501 58.3001H19.8101C19.8101 60.9001 21.9401 63.0001 24.5401 62.9701C27.0201 62.9401 29.1 60.8501 29.14 58.3701C29.18 55.7601 27.07 53.6401 24.47 53.6401V44.1601H24.4601C25.1201 44.0101 25.7101 43.7001 26.2001 43.2601L46.36 65.5601H19.8101V76.9401C19.8101 80.2801 22.52 82.9901 25.86 82.9901H28.8201C28.8601 88.3801 33.24 92.7301 38.64 92.7301C44.04 92.7301 48.4101 88.3801 48.4601 82.9901H64.39C64.39 88.4101 68.7901 92.8101 74.2101 92.8101C79.6301 92.8101 84.0301 88.4101 84.0301 82.9901H86.9901C90.33 82.9901 93.0401 80.2801 93.0401 76.9401V68.1301C93.0401 65.8801 92.2101 63.7101 90.7001 62.0401L73.8 43.3501C72.08 41.4501 69.6301 40.3601 67.0601 40.3601H62.5301C62.5001 38.2801 60.8001 36.6001 58.7101 36.6001C56.6201 36.6001 54.92 38.2801 54.89 40.3601",
    fill: "url(#paint8_linear_4_398)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4_398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 36,
    width: 75,
    height: 57
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4001 83.0001C70.4001 80.8901 72.1101 79.1701 74.2301 79.1701C76.3501 79.1701 78.0601 80.8801 78.0601 83.0001C78.0601 85.1201 76.3501 86.8301 74.2301 86.8301C72.1101 86.8301 70.4001 85.1201 70.4001 83.0001ZM34.83 82.9201C34.83 80.8101 36.5401 79.0901 38.66 79.0901C40.78 79.0901 42.4901 80.8001 42.4901 82.9201C42.4901 85.0401 40.78 86.7501 38.66 86.7501C36.5401 86.7501 34.83 85.0401 34.83 82.9201ZM58.94 49.6001H65.1801C66.0501 49.6001 66.8801 49.9701 67.4501 50.6301L80.5701 65.5701H58.94V49.6001ZM54.9001 40.3601H51.0301C49.3601 40.3601 48 41.7201 48 43.3901V53.8401L44.0701 49.5001C39.7101 44.6801 33.8101 41.5901 27.4501 40.7001C27.4501 40.6101 27.4601 40.5201 27.4601 40.4301C27.4601 38.3201 25.7501 36.6001 23.6301 36.6001C21.5101 36.6001 19.8 38.3101 19.8 40.4301C19.8 42.5501 21.5101 44.2601 23.6301 44.2601H23.6501C22.4001 44.5701 21.4701 45.6901 21.4701 47.0301V56.5801H24.47C25.52 56.5801 26.3601 57.5301 26.1701 58.6201C26.0501 59.3101 25.4801 59.8801 24.7901 60.0001C23.7001 60.1901 22.7501 59.3601 22.7501 58.3001H19.8101C19.8101 60.9001 21.9401 63.0001 24.5401 62.9701C27.0201 62.9401 29.1 60.8501 29.14 58.3701C29.18 55.7601 27.07 53.6401 24.47 53.6401V44.1601H24.4601C25.1201 44.0101 25.7101 43.7001 26.2001 43.2601L46.36 65.5601H19.8101V76.9401C19.8101 80.2801 22.52 82.9901 25.86 82.9901H28.8201C28.8601 88.3801 33.24 92.7301 38.64 92.7301C44.04 92.7301 48.4101 88.3801 48.4601 82.9901H64.39C64.39 88.4101 68.7901 92.8101 74.2101 92.8101C79.6301 92.8101 84.0301 88.4101 84.0301 82.9901H86.9901C90.33 82.9901 93.0401 80.2801 93.0401 76.9401V68.1301C93.0401 65.8801 92.2101 63.7101 90.7001 62.0401L73.8 43.3501C72.08 41.4501 69.6301 40.3601 67.0601 40.3601H62.5301C62.5001 38.2801 60.8001 36.6001 58.7101 36.6001C56.6201 36.6001 54.92 38.2801 54.89 40.3601",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0601 36.6001H19.8301V92.8201H93.0601V36.6001Z",
    fill: "url(#paint9_linear_4_398)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M299.2 82.06L298.97 76.9601C296.5 81.2901 290.62 83.84 283.59 83.84C269.37 83.84 260.33 70.63 260.33 56.33C260.33 41.18 268.98 29.05 285.6 29.05C297.81 29.05 307.24 36.31 308.01 46.59H297.19C296.65 41.8 291.47 37.94 285.6 37.94C277.02 37.94 271.3 44.5901 271.3 56.7901C271.3 65.2101 275.55 74.7901 285.52 74.7901C292.55 74.7901 298.04 69.46 298.04 63.05H286.68V54.47H308.08V82.06H299.19H299.2Z",
    fill: "url(#paint10_linear_4_398)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M310.25 63.05C310.25 51 317.75 43.04 329.8 43.04C341.85 43.04 349.12 50.92 349.12 63.05C349.12 75.18 341.63 83.06 329.8 83.06C317.97 83.06 310.25 74.87 310.25 63.05ZM338.99 63.05C338.99 55.32 335.9 51.54 329.79 51.54C323.68 51.54 320.59 55.33 320.59 63.05C320.59 70.77 323.68 74.64 329.79 74.64C335.9 74.64 338.99 70.78 338.99 63.05Z",
    fill: "url(#paint11_linear_4_398)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M351.82 82.0601V30.1301H361.86V82.0601H351.82Z",
    fill: "url(#paint12_linear_4_398)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M391.46 82.0601L391.38 77.4201C388.98 81.2801 385.43 83.0601 380.79 83.0601C371.21 83.0601 364.33 75.4901 364.33 62.6601C364.33 51.1501 370.13 43.0301 379.94 43.0301C384.65 43.0301 388.36 44.9601 391.22 48.9801V30.1301H401.11V82.0601H391.45H391.46ZM391.61 63.9801C391.61 55.7101 388.75 51.6201 383.19 51.6201C377.32 51.6201 374.53 55.5601 374.53 63.3701C374.53 70.1701 378.08 74.8801 383.11 74.8801C388.14 74.8801 391.61 70.4001 391.61 63.9801Z",
    fill: "url(#paint13_linear_4_398)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.72 82.0501V34.8901H149.53C158.76 34.8901 164.66 41.6401 164.66 50.1601C164.66 58.6801 158.77 64.9301 149.53 64.9301H138.59V82.0501H128.72ZM147.96 56.9101C153.64 56.9101 155.99 54.0001 155.99 49.8801C155.99 45.9701 153.65 43.0601 147.96 43.0601H138.58V56.9101H147.96Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.86 82.0501V34.3201H176.09V82.0501H166.86Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201.87 82.0502C201.59 81.2002 201.37 79.9902 201.3 78.9302C199.1 81.3502 195.4 82.9802 190.72 82.9802C182.76 82.9802 179.07 79.0702 179.07 73.3902C179.07 63.3002 185.82 62.1702 195.12 60.8902C199.74 60.2502 201.01 59.3302 201.01 56.9102C201.01 54.6402 198.74 53.2902 195.12 53.2902C190.93 53.2902 189.22 55.3502 188.8 58.4702H180.21C180.35 51.2202 184.33 46.1802 195.55 46.1802C206.77 46.1802 210.47 51.1502 210.47 59.9602V82.0502H201.88H201.87ZM201.23 64.9402C200.31 65.8602 198.67 66.3602 195.26 67.0002C190 68.0002 188.3 69.4902 188.3 72.4702C188.3 75.1002 189.86 76.3802 192.77 76.3802C197.53 76.3802 201.08 72.9002 201.15 68.7802L201.22 64.9402H201.23Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.89 82.0502V60.8802C236.89 55.4802 235.33 53.9902 230.92 53.9902C226.09 53.9902 223.75 56.6902 223.75 62.0202V82.0502H214.52V47.1002H223.33V52.2102C225.46 48.3002 229.01 46.1702 234.62 46.1702C241.3 46.1702 246.2 50.2202 246.2 57.8202V82.0402H236.89V82.0502Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_398",
    x1: 0.0300293,
    y1: 56.44,
    x2: 112.86,
    y2: 56.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_398",
    x1: -8.98837,
    y1: 42.6376,
    x2: 103.935,
    y2: 42.6376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_398",
    x1: 53.13,
    y1: 33.42,
    x2: 64.32,
    y2: 33.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_398",
    x1: 61.0845,
    y1: 46.422,
    x2: 72.278,
    y2: 46.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_398",
    x1: 49.7201,
    y1: 28.57,
    x2: 67.7301,
    y2: 28.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_398",
    x1: 34.0841,
    y1: 4.074,
    x2: 52.1096,
    y2: 4.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_398",
    x1: 45.77,
    y1: 23.8799,
    x2: 72.1,
    y2: 23.8799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_398",
    x1: 59.168,
    y1: 44.6939,
    x2: 85.52,
    y2: 44.6939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_398",
    x1: 19.83,
    y1: 64.7101,
    x2: 93.0601,
    y2: 64.7101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_398",
    x1: -0.359923,
    y1: 34.5097,
    x2: 72.9377,
    y2: 34.5097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_398",
    x1: 260.33,
    y1: 56.44,
    x2: 308.08,
    y2: 56.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_398",
    x1: 310.25,
    y1: 63.05,
    x2: 349.11,
    y2: 63.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_398",
    x1: 351.82,
    y1: 56.0901,
    x2: 361.86,
    y2: 56.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4_398",
    x1: 364.34,
    y1: 56.6001,
    x2: 401.12,
    y2: 56.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE762A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DDB663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F4D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE762A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPlanGold);
export default __webpack_public_path__ + "static/media/infoPlanGold.d1d6de555aa9160b5f13846063c0c0f4.svg";
export { ForwardRef as ReactComponent };